/** Matches the API's limit, which is the 5 MB Sendback.aspx allowed. */
export const MAX_OBSERVATION_MB = 5;

/** Checks a chosen observation letter before it is sent. Returns a message, or null. */
export function observationLetterProblem(file: File | null): string | null {
  if (!file) return 'Please upload the Observation Letter file for sending corrections.';
  if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf'))
    return 'Please upload the observation letter in pdf format.';
  if (file.size > MAX_OBSERVATION_MB * 1024 * 1024)
    return `Uploaded file size should not be more than ${MAX_OBSERVATION_MB} MB.`;
  return null;
}

interface ObservationLetterFieldProps {
  id: string;
  file: File | null;
  onChange: (file: File | null) => void;
  /** Bumped by the parent after a successful send-back so the input clears. */
  resetKey: number;
}

/**
 * The observation letter a committee office must attach when it sends a
 * proposal back, as on Sendback.aspx. It is e-mailed to the researcher and
 * merged in front of the proposal when it is resubmitted.
 */
export function ObservationLetterField({ id, file, onChange, resetKey }: ObservationLetterFieldProps) {
  return (
    <div className="field" style={{ marginTop: 'var(--space-3)' }}>
      <label className="field-label" htmlFor={id}>
        Observation letter
      </label>
      <p className="field-hint">
        Required when sending back — PDF, up to {MAX_OBSERVATION_MB} MB. Sent to the researcher
        and placed in front of the proposal when it is resubmitted.
      </p>
      <input
        key={resetKey}
        id={id}
        className="file-input"
        type="file"
        accept="application/pdf"
        onChange={(e) => onChange(e.target.files?.[0] ?? null)}
      />
      {file ? <p className="muted">{file.name}</p> : null}
    </div>
  );
}
